// opervex-frontend/src/Opervex/HumanResources/Sectors.js

class Sectors {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  // Create
  async create(data) {
    return this.#_api.post("/HumanResources/Sectors/", data);
  }

  // Update
  async update(id, data) {
    return this.#_api.put("/HumanResources/Sectors/" + id, data);
  }

  // Find By Id
  async findId(id) {
    return this.#_api.get("/HumanResources/Sectors/" + id);
  }

  // Find All
  async findAll() {
    return this.#_api.get("/HumanResources/Sectors");
  }

  //Schema

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default Sectors;
